export default {
  // Duplicate Survey Confirmation Dialog
  repeatConfirmTitle: "Duplicate Survey Confirmation",
  addTotal: "A total of ",
  addCount:
    " survey data items have been added this time. The following data has been added to the survey suggestions. Please confirm whether you need to continue adding to the survey?",

  // Table Columns
  addedBy: "Added By",
  addedTime: "Added Time",
  type: "Type",
  address: "Address",

  // Buttons
  cancel: "Cancel",
  confirm: "Confirm",

  // Survey Type Titles
  normalSurvey: "Normal Survey",
  keySurvey: "Key Survey",

  // Survey Categories
  exchangeSurvey: "Exchange Survey",
  exchangeSurveyDesc: "System can automatically match exchange survey data",
  huobiSurvey: "Huobi Platform Survey",
  huobiSurveyDesc: "User confirmation required",
  huobiTip:
    "Since Huobi stopped registering new users in mainland China on September 24, 2021, surveys for mainland users and overseas users will involve different survey channels. The system has calculated the priority survey channel based on the current survey data characteristics. If there is no survey result for this channel, users can manually switch to other channels to re-survey.",
  walletSurvey: "Wallet Survey",
  walletSurveyDesc: "Users need to select wallet platform themselves",

  // Form Fields
  surveyPlatform: "Survey Platform",
  selectPlatform: "Please select survey platform",
  selectOption: "Please select",
  surveyReason: "Survey Reason",
  inputReason: "Please enter survey reason",

  // Prompt Messages
  selectSurveyData: "Please select the survey data to be added",
  selectWalletPlatform: "Please select wallet survey platform",
  inputReasonRequired: "Please enter survey reason",
  addSuccess: "Added to survey",
  successTitle: "Success",

  // Type Labels
  hashType: "Hash",
};
